/* eslint-disable no-throw-literal */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button } from "semantic-ui-react"
import { responseError } from "../../helpers"
import { v4 as uuid } from 'uuid';
import { setSnackbar } from "../../actions/snackbar.actions";
import { addEstateManualInputDocument } from "../../actions/estate-manual-input.actions";

const CopyDocument = ({documentToCopy, setActiveTab}) => {
    const [showButton, setShowButton] = useState(false)
    const estateManualInputDocuments = useSelector(state => state.estateManualInputDocuments);
    const estateManualInput = useSelector(state => state.estateManualInput);
    const estateManualInputAssets = useSelector(state => state.estateManualInputAssets);
    const dispatch = useDispatch();

    const infoDocument = estateManualInputDocuments?.[documentToCopy]

    const verifyShowButton = () => {
        if(infoDocument?.type !== "General" && !infoDocument?.isJoint){
            setShowButton(true)
        }else{
            setShowButton(false)
        }
    }

    const copyDoc = () => {
        const confirmation = confirm(`Are you sure to copy?`)
        if(confirmation){
            try {
                const newId = uuid();
                const dataDataPoint = JSON.parse(JSON.stringify(estateManualInput?.[documentToCopy] || {}))
                if(Object.keys(dataDataPoint).length === 0){
                    throw { message: "🦗 Nothing to copy..." }
                }
                for(const key in estateManualInputAssets){
                    if(key.includes(documentToCopy)){
                        const newKey = key.replace(documentToCopy, newId)
                        estateManualInputAssets[newKey] = JSON.parse(JSON.stringify(estateManualInputAssets[key]))
                    }
                }

                for(const keyDatapoint in dataDataPoint){
                    const [normalKey, assetId] = keyDatapoint.split("___");
                    if(assetId){
                        const newAssetId = uuid();
                        const newKey = keyDatapoint.replace(assetId, newAssetId);
                        dataDataPoint[newKey] = dataDataPoint[keyDatapoint];
                        delete dataDataPoint[keyDatapoint];
                        for(const item of estateManualInputAssets[`${newId}_${normalKey}`]){
                            if(item?.id === assetId){
                                item.id = newAssetId;
                            }
                        }

                    }
                }

                dispatch(addEstateManualInputDocument(infoDocument?.type, newId, infoDocument?.isJoint, dataDataPoint));
                dispatch(setSnackbar({message: "Document Copied!"}))
                setActiveTab(newId)
            } catch (error) {
                responseError(error, undefined, "CopyDocument.copyDoc", dispatch)
                console.log({error})
            }
        }
    }

    useEffect(() => {
        verifyShowButton()
    },[documentToCopy])

    return <>
        {showButton &&
            <Button color="purple" onClick={() => copyDoc()}>
                Copy this document
            </Button>
        }
    </>
}

export default CopyDocument